// employer panel routes
export const profile = 'employer-panel/profile'
// export const profileShow = profile + 'show'
// export const profileStore = profile + 'store'
// export const profileUpdate = profile + 'update'

// Candidate/Applicant List
const candidateApplicant = 'employer-panel/candidate-applicant/'
export const candidateApplicantList = candidateApplicant + 'list'
export const candidateApplicantShow = candidateApplicant + 'show'
export const candidateApplicantToggleStatus = candidateApplicant + 'toggle-status'

// Candidate/Job Fair Circular List
const jobFairCircular = 'employer-panel/job-fair-circular/'
export const jobFairCircularList = jobFairCircular + 'list'
export const reportHeadingList = '/configuration/report-heading/detail'

//  Sorting Applicant List
const sortingApplicant = 'employer-panel/Sorting-applicant/'
export const sortingApplicantList = sortingApplicant + 'list'
export const sortingApplicanData = sortingApplicant + 'applicant-data'
export const sortingApplicanStoreData = sortingApplicant + 'store'
export const confirmedApplicantData = sortingApplicant + 'confirm-status'

//  Confirmation List
const confirmationList = 'employer-panel/confirm_list/'
export const confirmationListData = confirmationList + 'confirm_data'

// CV View
export const resumeViewApi = 'job-fair-management/cv/view'
export const jobFairCirculationBaseUrlApi = 'job-fair-management/job-fair-circulations/'
export const jobFairCirculationListApi = jobFairCirculationBaseUrlApi + 'list'
export const jobFairCirculationShowApi = jobFairCirculationBaseUrlApi + 'show'

// dashboar routes...
export const employerdashboardApi = 'employer-panel/employer-dashboard/dashboard-list'
export const CvBankresumeViewApi = 'job-fair-management/cv-bank/resumeview'
